import React, { useState } from "react";
import LandingPage from "./LandingPage";
import PartitionSystem from "./PartitionSystem";

/**
 * Main Router Component
 *
 * This is a simple container that switches between:
 * - LandingPage (when showLanding = true)
 * - PartitionSystem (when showLanding = false)
 *
 * Keep this file minimal - all logic lives in the child components
 */
const LandPartitionSystem = () => {
  const [showLanding, setShowLanding] = useState(true);

  if (showLanding) {
    return <LandingPage onStartPartition={() => setShowLanding(false)} />;
  }

  return <PartitionSystem onBackToLanding={() => setShowLanding(true)} />;
};

export default LandPartitionSystem;
